import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import MuiToolbar, { ToolbarProps as MuiToolbarProps } from '@mui/material/Toolbar';
import { CSSObject, styled } from '@mui/material/styles';
import { ElementType } from 'react';

/**
 * Drawer (Sidebar) Width
 */
const drawerWidth: number = 280;

/**
 * AppBar Props
 */
interface AppBarProps extends MuiAppBarProps {
    component?: ElementType;
    open?: boolean;
}

/**
 * Styled AppBar
 */
export const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop: PropertyKey) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
    backgroundColor: '#FDFDFD',
    height: '65px',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),

    ...(open && {
        marginLeft: drawerWidth,

        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        borderLeft: '1px solid #f2f7fb',
    }),
}));

/**
 * Toolbar Props
 */
interface ToolbarProps extends MuiToolbarProps {
    id?: string;
}

/**
 * Styled Toolbar
 */
export const Toolbar = styled(MuiToolbar)<ToolbarProps>({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
});

/**
 * Button Styles
 */
export const colorStyles: CSSObject = {
    color: 'primary.contrastText',
};
